/* ============================================================
   gtx-image-search.js — 官網「以圖搜圖 / 画像で探す」（架構⑦ 2026-06-30）
   ------------------------------------------------------------
   客が手元の生地画像をアップ → ERP /account/image-search（CLIP 類似度）
   → 相符品番カードを表示（クリックで商品頁へ）。舊柄難找の解決。
   権限は ERP 側で適用済（日本布は C/散客に出ない・廠商名は D/E のみ・
   進価/別客資料は一切出ない）。前台は受け取った物しか出せない。
   多語：document lang から ja/en/zh を判定。
   利用：snippets/gtx-image-search.liquid が本 JS を読み、起動ボタンを置く。
   ============================================================ */
(function () {
  "use strict";
  if (window.GTXImageSearch) return;   // 全站 layout ＋ 検索頁スニペットの二重ロード対策（modal 二重表示防止）
  var ERP = "https://erp.greentex.jp";
  var EP = ERP + "/account/image-search";

  function lang() {
    var l = (document.documentElement.lang || "ja").toLowerCase();
    if (l.indexOf("zh") === 0) return "zh";
    if (l.indexOf("en") === 0) return "en";
    return "ja";
  }
  var L = lang();
  var T = {
    ja: { title: "画像で探す", sub: "お手元の生地画像をアップすると、近い品番をお探しします。柄を1つだけ大きく写すと精度が上がります。",
          pick: "画像を選ぶ／ドロップ", searching: "照合中…", none: "近い品番が見つかりませんでした。",
          inquiry: "お見積り", disc: "廃番（要お問合せ）", retail: "参考価格", per: "/m", close: "閉じる",
          match: "類似度", err: "検索に失敗しました。時間をおいて再度お試しください。" },
    zh: { title: "以圖搜圖", sub: "上傳您手上的布料圖案，幫您找出最相近的品番。一次只拍一個圖案、拍大一點，準確度最高。",
          pick: "選擇圖片／拖曳", searching: "比對中…", none: "找不到相近的品番。",
          inquiry: "洽詢報價", disc: "廢版（請洽詢）", retail: "參考價", per: "/m", close: "關閉",
          match: "相似度", err: "搜尋失敗，請稍後再試。" },
    en: { title: "Search by Image", sub: "Upload a fabric image to find the closest matching items. Close-up of a single print works best.",
          pick: "Choose / drop image", searching: "Matching…", none: "No close match found.",
          inquiry: "Get a quote", disc: "Discontinued (inquire)", retail: "Ref. price", per: "/m", close: "Close",
          match: "Match", err: "Search failed. Please try again later." }
  }[L];

  function esc(s){return (s==null?"":String(s)).replace(/[&<>"']/g,function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c];});}

  var CSS = ""
    + ".gtx-is-ov{position:fixed;inset:0;background:rgba(20,28,26,.55);z-index:9999;display:flex;align-items:flex-start;justify-content:center;overflow:auto;padding:5vh 16px}"
    + ".gtx-is-box{background:#fff;max-width:760px;width:100%;border-radius:14px;padding:24px;box-shadow:0 16px 48px rgba(0,0,0,.25);font-family:inherit}"
    + ".gtx-is-h{font-size:20px;font-weight:700;color:#1f2a27;margin:0 0 4px}"
    + ".gtx-is-sub{font-size:13px;color:#5b6b66;margin:0 0 16px}"
    + ".gtx-is-drop{border:2px dashed #b9c8c2;border-radius:10px;padding:34px;text-align:center;color:#5b6b66;cursor:pointer;transition:.15s}"
    + ".gtx-is-drop:hover,.gtx-is-drop.drag{border-color:#278473;background:#f3faf7;color:#278473}"
    + ".gtx-is-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:14px;margin-top:18px}"
    + ".gtx-is-card{border:1px solid #e6ece9;border-radius:10px;overflow:hidden;text-decoration:none;color:inherit;display:block;transition:.15s}"
    + ".gtx-is-card:hover{box-shadow:0 6px 18px rgba(39,132,115,.18);transform:translateY(-2px)}"
    + ".gtx-is-card img{width:100%;aspect-ratio:1/1;object-fit:cover;display:block;background:#f4f4f4}"
    + ".gtx-is-meta{padding:8px 10px}"
    + ".gtx-is-code{font-weight:700;font-size:13px;color:#1f2a27;font-variant-numeric:lining-nums tabular-nums}"
    + ".gtx-is-price{font-size:13px;color:#278473;margin-top:2px}"
    + ".gtx-is-tag{display:inline-block;font-size:11px;color:#8a7a3a;background:#fbf6e3;border-radius:4px;padding:1px 6px;margin-top:2px}"
    + ".gtx-is-badge{position:absolute;}"
    + ".gtx-is-m{font-size:11px;color:#9aa6a1;margin-top:2px}"
    + ".gtx-is-close{float:right;border:none;background:none;font-size:14px;color:#5b6b66;cursor:pointer}"
    + ".gtx-is-status{text-align:center;color:#5b6b66;padding:20px;font-size:14px}"
    + ".gtx-is-prev{max-height:120px;border-radius:8px;margin:0 auto 10px;display:block}";

  function injectCss(){ if(document.getElementById("gtx-is-css"))return;
    var s=document.createElement("style"); s.id="gtx-is-css"; s.textContent=CSS; document.head.appendChild(s); }

  function open() {
    injectCss();
    var ov=document.createElement("div"); ov.className="gtx-is-ov";
    ov.innerHTML=''
      +'<div class="gtx-is-box" role="dialog" aria-label="'+esc(T.title)+'">'
      +'<button class="gtx-is-close" aria-label="'+esc(T.close)+'">✕ '+esc(T.close)+'</button>'
      +'<h2 class="gtx-is-h">'+esc(T.title)+'</h2>'
      +'<p class="gtx-is-sub">'+esc(T.sub)+'</p>'
      +'<div class="gtx-is-drop" id="gtx-is-drop">'+esc(T.pick)+'</div>'
      +'<input type="file" accept="image/*" id="gtx-is-file" style="display:none">'
      +'<div id="gtx-is-out"></div>'
      +'</div>';
    document.body.appendChild(ov);
    var box=ov.querySelector(".gtx-is-box");
    var drop=ov.querySelector("#gtx-is-drop");
    var file=ov.querySelector("#gtx-is-file");
    var out=ov.querySelector("#gtx-is-out");
    function close(){ ov.remove(); }
    ov.addEventListener("click",function(e){ if(e.target===ov) close(); });
    box.querySelector(".gtx-is-close").addEventListener("click",close);
    drop.addEventListener("click",function(){ file.click(); });
    drop.addEventListener("dragover",function(e){ e.preventDefault(); drop.classList.add("drag"); });
    drop.addEventListener("dragleave",function(){ drop.classList.remove("drag"); });
    drop.addEventListener("drop",function(e){ e.preventDefault(); drop.classList.remove("drag");
      if(e.dataTransfer.files && e.dataTransfer.files[0]) go(e.dataTransfer.files[0]); });
    file.addEventListener("change",function(){ if(file.files[0]) go(file.files[0]); });

    function go(f){
      var prev=URL.createObjectURL(f);
      out.innerHTML='<img class="gtx-is-prev" src="'+prev+'"><div class="gtx-is-status">'+esc(T.searching)+'</div>';
      var fd=new FormData(); fd.append("image",f);
      var _st=0;
      fetch(EP,{method:"POST",body:fd,credentials:"include"})
        .then(function(r){ _st=r.status; return r.json().catch(function(){ return null; }); })
        .then(function(d){ render(d,prev,_st); })
        .catch(function(){ out.innerHTML='<div class="gtx-is-status">'+esc(T.err)+'</div>'; });
    }
    function priceLine(it){
      if(it.mode==="discontinued") return '<span class="gtx-is-tag">'+esc(T.disc)+'</span>';
      if(it.mode==="price" && it.per_m) return '<div class="gtx-is-price">¥'+Number(it.per_m).toLocaleString()+esc(T.per)+'</div>';
      if(it.mode==="retail" && it.per_m) return '<div class="gtx-is-price">'+esc(T.retail)+' ¥'+Number(it.per_m).toLocaleString()+esc(T.per)+'</div>';
      return '<span class="gtx-is-tag">'+esc(T.inquiry)+'</span>';
    }
    function render(d,prev,st){
      // Round 315（2026-08-12）：伺服器錯誤を「見つかりません」に化けさせない。
      //   索引欠落(503 index_not_built) を "近い品番なし" と表示していたため、
      //   実際はエンジンが動いていないのに「柄が無い」と誤解された（CEO 実害・2026-08-12）。
      if(st && st!==200){
        try{ console.error("[gtx-image-search] HTTP "+st, d && d.error); }catch(e){}
        out.innerHTML='<img class="gtx-is-prev" src="'+prev+'"><div class="gtx-is-status">'+esc(T.err)+'</div>'; return;
      }
      if(!d || !d.ok){
        try{ console.error("[gtx-image-search] ", d && d.error); }catch(e){}
        out.innerHTML='<img class="gtx-is-prev" src="'+prev+'"><div class="gtx-is-status">'+esc(T.err)+'</div>'; return;
      }
      if(!d.items || !d.items.length){
        out.innerHTML='<img class="gtx-is-prev" src="'+prev+'"><div class="gtx-is-status">'+esc(T.none)+'</div>'; return;
      }
      var html='<img class="gtx-is-prev" src="'+prev+'"><div class="gtx-is-grid">';
      d.items.forEach(function(it){
        var img=it.image?(ERP+it.image):"";
        var pct=Math.round((it.score||0)*100);
        html+=''
          +'<a class="gtx-is-card" href="'+(it.url||"#")+'"'+(it.url?'':' onclick="return false"')+'>'
          +(img?'<img loading="lazy" src="'+esc(img)+'" alt="'+esc(it.code)+'">':'')
          +'<div class="gtx-is-meta">'
          +'<div class="gtx-is-code">'+esc(it.code)+'</div>'
          + priceLine(it)
          +'<div class="gtx-is-m">'+esc(T.match)+' '+pct+'%</div>'
          +'</div></a>';
      });
      html+='</div>';
      out.innerHTML=html;
    }
  }

  window.GTXImageSearch = { open: open };
  // data-gtx-image-search 属性のボタンに自動バインド
  document.addEventListener("click", function(e){
    var t=e.target.closest && e.target.closest("[data-gtx-image-search]");
    if(t){ e.preventDefault(); open(); }
  });
})();
